/* global _satellite */ // ESLint
/* @ngInject */
import { isAdobeSatelliteTrackingReady } from '../../utils';

function AdobeFactory() {
  let trafficObj = $('#trafficDataObject');
  let trafficObjJson = JSON.parse(
    trafficObj.text() === '' ? '""' : trafficObj.text()
  );
  let cartObj = $('#cartDataObject');
  let cartObjJson = JSON.parse(cartObj.text() === '' ? '""' : cartObj.text());
  let locResourcesKeys = {
    required: 'checkout.form.required.error',
    email: 'general.email.error',
    pattern: 'checkout.form.specialchars.error',
    minlength: 'checkout.form.size.error',
    maxlength: 'checkout.form.size.error',
    generalError: 'checkout.register.error',
    ccNumber: 'checkout.payment.creditcard.type_not_supported', // Used when the credit card number is not valid
    generalFormError: 'checkout.form.invalid.error',
  };

  return {
    setTrafficObjProperty: function (property, value) {
      if (trafficObjJson !== '') trafficObjJson.traffic[property] = value;
    },
    setCartObjProperty: function (isNested, propertyA, propertyB, value) {
      if (cartObj !== '') {
        if (isNested) cartObjJson[propertyA][propertyB] = value;
        else cartObjJson[propertyA] = value;
      }
    },
    setTrafficNotifications: function (type, locResource) {
      if (trafficObjJson !== '')
        trafficObjJson.traffic.notifications = [
          { type: type, key: locResourcesKeys[locResource] },
        ];
    },
    // Function to update the traffic & cart html obj
    // Default name is checkout_register
    setTrackingAndUpdate: function (functionName = 'checkout_register') {
      if (trafficObjJson !== '' && cartObj !== '') {
        trafficObj.text(JSON.stringify(trafficObjJson));
        cartObj.text(JSON.stringify(cartObjJson));
        this.callTracking(functionName);
      }
    },
    // Clean the notifications obj to avoid dragging errors to the next sections
    cleanTrackingNotifications: function () {
      if (trafficObjJson !== '') {
        trafficObjJson.traffic.notifications = [];
        trafficObj.text(JSON.stringify(trafficObjJson));
      }
    },
    // Function to build the object for the notifications that will be put in the traffic obj
    // and update the html element
    setTrackingErrors: function (errors, source) {
      if (trafficObjJson !== '') {
        trafficObjJson.traffic.notifications = this.makeTrackingErrorObj(
          errors,
          source
        );
        this.setTrackingAndUpdate();
      }
    },
    // Make the adobe call
    callTracking: function (eventName, eventPayload) {
      try {
        if (isAdobeSatelliteTrackingReady()) {
          _satellite.track(eventName, eventPayload && eventPayload);
        }
      } catch (e) {
        console.log('Error calling _satellite.track("checkout_register")', e);
      }
    },
    makeTrackingErrorObj: function (errors, source) {
      let errorsForTracking = [];
      if (source === 'front') {
        angular.forEach(errors, function (error, name) {
          if (name === 'validationError')
            errorsForTracking.push({
              type: 'error',
              key: locResourcesKeys.generalFormError,
            });
          else
            errorsForTracking.push({
              type: 'error',
              key: locResourcesKeys[name],
            });
        });
      } else {
        angular.forEach(errors, function (error) {
          errorsForTracking.push({ type: 'error', key: error.key });
        });
      }

      return errorsForTracking;
    },
  };
}

export default AdobeFactory;
